import React from 'react';
import PropTypes from 'prop-types';
import { TrackingContext } from '@vrbo/react-event-tracking';
import LYPValuePropItems from '../LYPValuePropItems';
import LypHeader from '../LypHeader';
import LypHowItworks from '../LypHowItWorks';
import Divider from '../Divider';
import PMValueProps from '../PMValueProps';
import Footer from '../../Footer';
import { Masthead } from '../../Masthead';

class VrboTemplate extends React.Component {
    // eslint-disable-next-line react/sort-comp
    static contextType = TrackingContext;

    render() {
        const {
            children,
            history,
            referrer
        } = this.props;
        return (
            <div className="ulx-antialias">
                <LypHeader history={history} referrer={referrer} />
                <Masthead>{children}</Masthead>
                <LYPValuePropItems />
                <Divider />
                <LypHowItworks />
                <PMValueProps />
                <Footer showCompliance />
            </div>
        );
    }
}

VrboTemplate.propTypes = {
    children: PropTypes.oneOfType([
        PropTypes.array,
        PropTypes.object
    ]).isRequired,
    history: PropTypes.shape({
        replace: PropTypes.func,
        location: PropTypes.shape({
            pathname: PropTypes.string
        }).isRequired
    }).isRequired,
    referrer: PropTypes.string.isRequired
};

export default VrboTemplate;
